import * as React from 'react';
import Header from './Header';
import Footer from './Footer';
import { LayoutProvider } from './Context';
import ToolBar from '../components/ToolBar';

const Layout = ({ children, location }) => {
  return (
    <LayoutProvider path={location.pathname}>
      <ToolBar />
      <Header />
      <main>
        {children}
      </main>
      <Footer />
    </LayoutProvider>
  );
};

export default Layout;
